// extracted by mini-css-extract-plugin
module.exports = {"Container":"SettingsSection_Container__3SGg2","Info":"SettingsSection_Info__2hIBy","Description":"SettingsSection_Description__2GULU","Content":"SettingsSection_Content__1Wyar"};